import { getCurrentSession } from '../../../lib/authentication'

export const fetch = (params) =>
  getCurrentSession().then(({ accessToken }) =>
    apigClient
      .ratingsGet(
        params,
        {},
        {
          headers: {
            Authorization: accessToken,
          },
        },
      )
      .then((resp) => resp.data)
      .catch((err) => {
        console.log({ err })
        throw err.data
      }),
  )
